<template>
  <div class="sites-public">

    <!-- Filtros -->
    <div class="filtros">
      <v-text-field
        v-model="filtroTexto"
        class="buscador-lugares"
        label="Buscar lugar..."
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        density="compact"
        hide-details
        clearable
        @keydown.enter="buscar"
        @click:clear="limpiarBusqueda"
      />
      <div class="chips-categorias">
        <v-chip
          :color="filtroCategoria === null ? 'primary' : 'default'"
          variant="tonal"
          class="chip-cat"
          @click="seleccionarCategoria(null)"
        >
          Todos
        </v-chip>
        <v-chip
          v-for="cat in categorias"
          :key="cat.idCategory"
          :color="filtroCategoria === cat.idCategory ? 'primary' : 'default'"
          variant="tonal"
          class="chip-cat"
          @click="seleccionarCategoria(cat.idCategory)"
        >
          {{ cat.name }}
        </v-chip>
      </div>
    </div>

    <!-- Cargando -->
    <div v-if="cargando" class="text-center py-10">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <!-- Sin resultados -->
    <div v-else-if="lugares.length === 0" class="empty-state">
      <v-icon size="52" color="grey-lighten-1">mdi-map-marker-off</v-icon>
      <p class="text-grey mt-2">No se encontraron lugares.</p>
      <p class="text-body-2 mt-1 mb-3">¿Conoces un lugar que deba aparecer aquí? Contáctanos.</p>
      <v-btn
        color="green"
        variant="tonal"
        prepend-icon="mdi-whatsapp"
        :href="`https://wa.me/57${whatsappNumber}`"
        target="_blank"
        rel="noopener"
      >
        Escríbenos al {{ whatsappNumber }}
      </v-btn>
    </div>

    <!-- Grid de lugares -->
    <div v-else class="grid-lugares">
      <SiteCard
        v-for="lugar in lugares"
        :key="lugar.idSite"
        :site="lugar"
        @click="$router.push({ name: 'ViewSiteView', params: { id: lugar.idSite } })"
      />
    </div>

    <!-- Paginación -->
    <div v-if="totalPaginas > 1" class="paginacion">
      <v-btn :disabled="paginaActual === 0" variant="text" icon @click="cambiarPagina(paginaActual - 1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span>{{ paginaActual + 1 }} / {{ totalPaginas }}</span>
      <v-btn :disabled="esUltima" variant="text" icon @click="cambiarPagina(paginaActual + 1)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>

  </div>
</template>

<script>
import apisSites from "@/apis/apisSites";
import Config from "@/Config";
import SiteCard from "@/components/SiteCard.vue";

export default {
  name: "SitesPublicView",
  components: { SiteCard },
  data() {
    return {
      lugares: [],
      categorias: [],
      cargando: false,
      whatsappNumber: Config.whatsapp,
      filtroTexto: "",
      filtroCategoria: null,
      paginaActual: 0,
      totalPaginas: 1,
      esUltima: true,
    };
  },
  created() {
    this.cargarCategorias();
    this.cargarLugares();
  },
  methods: {
    async cargarCategorias() {
      this.categorias = await apisSites.getCategoriesByEntityType("lugar");
    },
    async buscar() {
      this.paginaActual = 0;
      await this.cargarLugares();
    },
    limpiarBusqueda() {
      this.filtroTexto = "";
      this.buscar();
    },
    async seleccionarCategoria(idCategory) {
      this.filtroCategoria = idCategory;
      this.paginaActual = 0;
      await this.cargarLugares();
    },
    async cargarLugares() {
      this.cargando = true;
      try {
        const resp = await apisSites.search({
          page: this.paginaActual,
          text: this.filtroTexto || null,
          idCategory: this.filtroCategoria || null,
        });
        this.lugares = resp.content;
        this.totalPaginas = resp.totalPages;
        this.esUltima = resp.last;
      } finally {
        this.cargando = false;
      }
    },
    async cambiarPagina(nuevaPagina) {
      this.paginaActual = nuevaPagina;
      await this.cargarLugares();
    },
  },
};
</script>

<style scoped>
.sites-public {
  max-width: 700px;
  margin: 0 auto;
  padding: 16px;
}

.filtros {
  margin-bottom: 16px;
}

.chips-categorias {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.chip-cat {
  cursor: pointer;
}

/* Siempre una por fila: cada lugar es una tarjeta de fila completa, con el
   mosaico de fotos a la izquierda y la informacion a la derecha */
.grid-lugares {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

/* En computador la pagina se quedaba en 700px y dejaba media pantalla vacia
   a cada lado. Se ensancha a 1240px, igual que las vistas de detalle, y
   entran tres lugares por fila. El buscador se queda acotado porque un campo
   de texto de 1240px se ve raro. */
@media (min-width: 900px) {
  .sites-public {
    max-width: 1100px;
  }
  .buscador-lugares {
    max-width: 520px;
  }
}


.paginacion {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 16px;
  text-align: center;
}
</style>
